import { render, staticRenderFns } from "./ProductActivePage.vue?vue&type=template&id=52885b15&scoped=true&"
import script from "./ProductActivePage.vue?vue&type=script&lang=js&"
export * from "./ProductActivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52885b15",
  null
  
)

export default component.exports